import React, {Component} from 'react';
import asyncComponent from './components/AsyncComponent';
import SearchBar from './containers/SearchBar';

import './App.css';

const AsyncAlbumList = asyncComponent(() => import("./containers/AlbumList"));
const AsyncVideo = asyncComponent(() => import("./containers/Video"));

class App extends Component {
  render() {
    return (
      <div className="App">
        <header>
          <SearchBar />
        </header>
        <AsyncAlbumList />
        <AsyncVideo />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js